import React from 'react';
import { STORAGE_KEYS } from '../constants/storageKeys';
import AppShell from '../components/AppShell';
import { formatDate, formatINR, STATUS_STYLES, TXN_STYLES, getCategoryIcon } from '../utils/expenseFormat';

const DetailRow = ({ label, value }) => {
  if (value === null || value === undefined || value === '') return null;
  return (
    <div className="detail-row">
      <div className="detail-row__label">{label}</div>
      <div className="detail-row__value">{value}</div>
    </div>
  );
};

const ExpenseDetailScreen = ({ navigate, params, onBack }) => {
  const item = params?.expense;
  const isAdmin = localStorage.getItem(STORAGE_KEYS.EMP_CODE)?.toUpperCase() === 'A';

  if (!item) {
    return (
      <AppShell title="Expense Details" onBack={onBack}>
        <div style={{ textAlign: 'center', marginTop: 60, color: '#aaa', fontSize: 15 }}>
          Expense not found.
        </div>
      </AppShell>
    );
  }

  const catStyle = getCategoryIcon(item.ExpCatName);
  const status = STATUS_STYLES[item.Status];
  const txn = TXN_STYLES[item.TransactionType];

  return (
    <AppShell
      title="Expense Details"
      onBack={onBack}
      rightAction={isAdmin ? { icon: '✎', onClick: () => navigate('ExpenseForm', { expense: item }), label: 'Edit' } : undefined}
    >
      <div style={{ padding: 12, paddingBottom: 40 }}>
        <div className="detail-card">
          <div className="detail-header">
            <div className="detail-icon" style={{ background: catStyle.color }}>{catStyle.icon}</div>
            <div className="detail-header__text">
              <div className="detail-party">{item.ExpPartyName || 'No Party'}</div>
              <div className="detail-amount">−{formatINR(item.Amount || 0)}</div>
            </div>
          </div>

          <div className="detail-tags">
            {status && (
              <span
                className="detail-tag detail-tag--icon"
                style={{ color: status.color, background: status.bg }}
                title={status.label}
              >
                {status.icon}
              </span>
            )}
            {txn && (
              <span className="detail-tag" style={{ color: txn.color, background: '#f2f2f2' }}>
                {txn.icon} {txn.label}
              </span>
            )}
          </div>

          {item.Status === 'Rejected' && item.RejectionReason && (
            <div className="detail-alert">⚠️ Rejected: {item.RejectionReason}</div>
          )}

          <div className="detail-section">
            <DetailRow label="Date" value={formatDate(item.Date)} />
            <DetailRow label="Category" value={item.ExpCatName} />
            <DetailRow label="Sub Category" value={item.ExpSubCatName} />
            <DetailRow label="Account" value={item.AccountName} />
            <DetailRow label="Sub Account" value={item.SubAccountName} />
            <DetailRow label="Detail" value={item.Detail} />
            <DetailRow label="Narration" value={item.Narration} />
            <DetailRow label="Submitted By" value={item.InsertedByName} />
            <DetailRow label="Submitted On" value={item.InsertedOn ? formatDate(item.InsertedOn) : null} />
            <DetailRow label="Last Updated" value={item.UpdatedOn ? formatDate(item.UpdatedOn) : null} />
            {item.Status !== 'Pending' && (
              <DetailRow label={item.Status === 'Rejected' ? 'Rejected On' : 'Approved On'} value={item.ApprovedOn ? formatDate(item.ApprovedOn) : null} />
            )}
          </div>
        </div>
      </div>

      <style>{`
        .detail-card {
          background: #fff;
          border-radius: 12px;
          padding: 16px;
          box-shadow: 0 1px 4px rgba(0,0,0,0.08);
        }
        .detail-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }
        .detail-icon {
          width: 44px;
          height: 44px;
          border-radius: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          flex-shrink: 0;
        }
        .detail-header__text { flex: 1; min-width: 0; }
        .detail-party {
          font-size: 16px;
          font-weight: 700;
          color: #333;
        }
        .detail-amount {
          font-size: 20px;
          font-weight: 700;
          color: #c62828;
          margin-top: 2px;
        }
        .detail-tags {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
          margin-bottom: 4px;
        }
        .detail-tag {
          display: inline-block;
          padding: 3px 10px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 700;
        }
        .detail-tag--icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 26px;
          height: 26px;
          padding: 0;
          border-radius: 50%;
          font-size: 13px;
        }
        .detail-alert {
          margin-top: 10px;
          padding: 10px 12px;
          background: #FFEBEE;
          color: #c62828;
          border-radius: 8px;
          font-size: 13px;
        }
        .detail-section {
          margin-top: 12px;
          border-top: 1px solid #f0f0f0;
        }
        .detail-row {
          display: flex;
          justify-content: space-between;
          gap: 12px;
          padding: 10px 0;
          border-bottom: 0.5px solid #f5f5f5;
        }
        .detail-row:last-child { border-bottom: none; }
        .detail-row__label {
          font-size: 13px;
          color: #999;
          flex-shrink: 0;
        }
        .detail-row__value {
          font-size: 13px;
          color: #333;
          font-weight: 500;
          text-align: right;
        }
      `}</style>
    </AppShell>
  );
};

export default ExpenseDetailScreen;
